/*eslint-disable*/
import React, { useEffect, useState, useContext } from "react";
import Table from "../Shared/Table";
import Gallery from "./Gallery";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Button,
} from "reactstrap";

import Moment from "react-moment";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { elevator } from "core/UrlEndpoints";
import customerService from "core/api/CustomerService";
import buildingService from "core/api/BuildingService";
import HeaderInfoItem from "../Shared/HeaderInfoItem";
import HeaderAddress from "../Shared/HeaderAddress";
import { CrudDropdownEditDelete } from "../Shared/CrudDropdownEditDelete";
import { UserContext } from "context/UserContext";


const View = () => {
  const history = useHistory();
  const { id } = useParams();
  const { userHasAnyPermissions } = useContext(UserContext)
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    customerId: "",
    name: "",
    company: "",
    line1: "",
    line2: "",
    city: "",
    state: "NY",
    postalCode: "",
    country: "USA",
    phone: "",
    email: "",
  });
  const [customerData, setCustomerData] = useState({
    name: "",
    company: "",
    line1: "",
    line2: "",
    city: "",
    state: "NY",
    postalCode: "",
    country: "USA",
    phone: "",
    email: "",
  });
  const [elevatorCompanyName, setElevatorCompanyName] = useState("");
  const [defaultContact, setDefaultContact] = useState()

  useEffect(() => {
    async function fetchData() {
      const results = await buildingService.getBuildingWithDetails(id);
      setData(results.building);
      setCustomerData(results?.customer);
      setElevatorCompanyName(results?.elevatorCompanyName);
      setDefaultContact(results.building?.contacts.find(contact => contact.defaultContact)) 
      setLoading(false);
    }
    fetchData();
  }, [id]);

  if (loading) return <>Loading</>;

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h2 className="title">
              {customerData?.company ?? elevatorCompanyName} / {data.buildingName}
            </h2>
            {data.active === false && (
              <p style={{ color: "#f5a623", margin: 0, fontSize: "1.1em", fontWeight: "bold", letterSpacing: "2px" }}>
                INACTIVE
              </p>
            )}
          </div>
        }
      />
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardBody>
                {loading && <>loading</>}
                {loading || (
                  <Row>
                    <Col style={{ border: "1px" }}>
                      <HeaderInfoItem title="Company">
                        {customerData?.company ?? elevatorCompanyName}
                      </HeaderInfoItem>
                      <HeaderInfoItem title="Contact Name">
                        {customerData?.name}
                      </HeaderInfoItem>
                    </Col>
                    <Col>
                      <HeaderInfoItem title="Building">
                        {data.buildingName}
                      </HeaderInfoItem>
                      <HeaderInfoItem title="Building Account Number">
                        {data?.accountNumber ?? 0}
                      </HeaderInfoItem>
                    </Col>
                    <Col> 
                      <HeaderInfoItem title="Building Contact Name">
                        {defaultContact.contactName} 
                      </HeaderInfoItem>
                      <HeaderInfoItem title="Phone Number">
                        {defaultContact.phone}
                      </HeaderInfoItem>
                    </Col>
                    <Col>
                      <HeaderInfoItem title="Email Address">
                        {defaultContact.email}
                      </HeaderInfoItem>
                    </Col>
                    <Col>
                      <HeaderAddress {...data} />
                    </Col>
                    <Col xs="auto">
                      <CrudDropdownEditDelete
                        id={id}
                        onDelete={() => {
                          buildingService.delete(id);
                          history.goBack();
                        }}
                        deletePermissions={["all:buildings", "delete:buildings", "admin"]}
                        editPermissions={["all:buildings", "write:buildings", "admin"]}
                      />
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Elevators</CardTitle>
                {userHasAnyPermissions(["all:buildings", "write:buildings", "admin"]) &&
                <Button
                  color="primary"
                  onClick={() =>
                    history.push(
                      data.customerId ? `../elevators/${data.customerId}|${id}/add`
                        : `../elevators/company/${id}/add`
                      , { showBackButton: true }
                    )
                  }>
                  Add
                </Button>
                }
              </CardHeader>
              <CardBody>
                <Table
                  pathroot="../elevators"
                  url={elevator}
                  filters={{ BuildingId: id }}
                  columns={[
                    {
                      header: "Name",
                      accessorKey: "name",
                    },
                    { header: "Phone", accessorKey: "phoneNumber" },
                    {
                      header: "Is Billing",
                      accessorKey: "isBilling",
                      cell: ({ row }) => (
                        <>{row.original.isBilling ? "True" : "False"}</>
                      ),
                    },
                    {
                      header: "Last Status",
                      accessorKey: "LastStatus",
                    },
                    {
                      header: "Last Update Note",
                      accessorKey: "lastStatusNote",
                    },
                    {
                      header: "Last Status Updated",
                      accessorKey: "lastStatusUpdated",
                      cell: ({ row }) => (
                        <>
                          {row.original.lastStatusUpdated == null ? (
                            ""
                          ) : (
                            <Moment>{row.original.lastStatusUpdated}</Moment>
                          )}
                        </>
                      ),
                    },
                  ]}
                />
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Images</CardTitle>
              </CardHeader>
              <CardBody>
                <Gallery id={`buildings/${data.id}`}
                  deletePermissions={["all:buildings", "delete:buildings", "admin"]}
                  editPermissions={["all:buildings", "write:buildings", "admin"]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default View;
